<template>
  <div>
    <div class="main-header fixed top-0 left-0 right-0 z-20 flex justify-between p-4 items-center bg-white">
      <div class="flex flex-col">
        <img
        alt="Beyond Roast logo"
        src="../assets/beyond-roast-logo.svg"
        class="py-2"
      >
      <div class="text-xs">
          <button @click="changeLocale('pt-BR')" :class="getLocaleClass('pt-BR')">PT</button>
          <span class="mx-1 text-zinc-300">|</span>
          <button @click="changeLocale('en')" :class="getLocaleClass('en')">EN</button>
        </div>
      </div>
      <div class="flex items-center gap-3">

        <button
          class="bg-green text-white py-2 px-3 rounded-full text-sm"
          @click="openTallyForm" 
        >
        {{ $t('cta.notifyMe') }}
        </button>
      </div>
    </div>

    <div class="bg-light-gray">
      <div class="pin-roaster" :class="{'roaster-hero': isBackgroundVisible}">
        <div class="lg:flex lg:flex-row lg:items-center lg:gap-12 lg:px-8">
          <div class="headline-hero flex flex-col items-center justify-center pt-[110px] absolute w-full lg:static lg:w-[50%] lg:pt-0 lg:items-start">
            <h1 class="box catch-line text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold tracking-tight text-center lg:text-left mx-3 md:mx-auto mb-4 z-10 leading-tight max-w-2xl md:max-w-3xl lg:max-w-4xl" v-html="renderRich($t('hero.headline'))"></h1>
          </div>
          <div class="h-[150px] md:h-[100px] lg:hidden"></div>
          <div class="lg:w-7/12 lg:order-1">
            <canvas
              id="image-sequence"
              class="box z-10 w-full mx-auto image-sequence-canvas"
            />
          </div>
        </div>
      </div>
      <div>
        <!-- <h1 class="box text-2xl font-semibold text-brown text-center py-1 px-4"></h1> -->
        <section class="mt-4">
          <p class="box">
            <b>{{ $t('hero.sub1') }}</b>
            {{ $t('hero.sub2') }}
          </p>
          <div class="box flex justify-center mt-4 lg:mt-7">
            <button
              class="bg-green  text-white py-1 px-3 rounded-full"
              @click="openTallyForm"
            >
            {{ $t('cta.notifyMe') }}
            </button>
          </div>
        </section>

        <!-- <section class="px-0">
          <h1 class="box text-4xl font-semibold px-8">
            Controle ao seu alcance.
          </h1>
          <img
            alt="Roaster"
            src="../assets/touch-screen.png"
            class="product-image box mx-auto z-10"
          >
          <p class="box px-8">
            <b>
              Painel touch Integrado
            </b>
            fornece atualizações em tempo real e
            <b>
              controle total
            </b>
            do processo de torra.
          </p>
        </section> -->

        <section class="relative px-0 lg:mt-[100px]">
          <h1 class="box text-4xl lg:text-5xl xl:text-6xl font-normal px-8">{{ $t('bean.title') }}</h1>

          <div class="relative flex justify-start lg:justify-end w-full">
            <img
              alt="Roaster"
              src="../assets/beancoscreen.png"
              class="product-image h-[230px] lg:h-[350px] w-full object-cover object-right box z-10 w-full mr-[200px]"
            >
            <img
              alt="Roaster"
              src="../assets/coffee-bag.png"
              class="coffee-bag box mx-auto z-10 w-[140px] lg:w-[180px] xl:w-[220px] absolute bottom-[-5px] lg:bottom-[-10px] right-0"
            >
          </div>

          <p class="box bean-connect-description z-10 px-8" v-html="renderRich($t('bean.desc'))"></p>
          <img
            alt="Bean connect"
            src="../assets/bean-connect-bg.svg"
            class="absolute bottom-[-10%] left-[-30%] z-0"
          >
        </section>

        <section class="lg:mt-[100px]">
          <h1 class="box text-4xl lg:text-5xl xl:text-6xl font-normal">{{ $t('hero.efficiencyTitle') }}</h1>

          <img
            alt="Roaster"
            src="../assets/beyond-roast-coffee-shop.png"
            class="box mx-auto rounded-xl my-7 z-10 h-52 md:h-64 lg:h-80 xl:h-96 w-full object-cover"
          >

          <p class="box" v-html="renderRich($t('hero.efficiencyP1'))"></p>

          <div class="flex justify-center box mt-3">
            <button
              class="bg-green  text-white py-1 px-3 rounded-full"
              @click="openModal"
            >
              {{ $t('cta.calcROI') }}
            </button>
          </div>

          <img
            alt="Roaster"
            src="../assets/coffee-field.jpg"
            class="box mx-auto rounded-xl my-7 z-10 h-52 md:h-64 lg:h-80 xl:h-96 w-full object-cover lg:mt-[50px]"
          >

          <p class="box" v-html="renderRich($t('hero.envP1'))"></p>
          <div class="box flex justify-center mt-4">
            <button
              class="bg-green  text-white py-1 px-3 rounded-full"
              @click="openTallyForm"
            >
            {{ $t('cta.notifyMe') }}
            </button>
          </div>
        </section>

        <section class="bg-white py-7 box rounded-xl lg:mt-[100px]">
          <h1 class="text-4xl lg:text-5xl xl:text-6xl font-normal">{{ $t('features.title') }}</h1>
          <div class="my-4">
            <KeyFeature
              :title="$t('features.f1Title')"
              :text="$t('features.f1Text')"
            />
            <KeyFeature
              :title="$t('features.f2Title')"
              :text="$t('features.f2Text')"
            />
            <KeyFeature
              :title="$t('features.f3Title')"
              :text="$t('features.f3Text')"
            />
            <KeyFeature
              :title="$t('features.f4Title')"
              :text="$t('features.f4Text')"
            />
            <KeyFeature
              :title="$t('features.f5Title')"
              :text="$t('features.f5Text')"
            />
          </div>
          <div class="flex justify-center mt-3">
            <button
              class="bg-green  text-white py-1 px-3 rounded-full"
              @click="openTallyForm"
            >
            {{ $t('cta.notifyMe') }}
            </button>
          </div>
        </section>

      </div>
    </div>
    <footer class="bg-white p-7">
      <img
        alt="Beyond Roast logo"
        src="../assets/beyond-roast-logo.svg"
      >
    </footer>

    <ROIModal v-model:value="isModalOpened" />
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import ROIModal from './ROIModal.vue';
import KeyFeature from './KeyFeature.vue';
import { linkFormSubmission } from '../services/statistics';
import { i18n, setLocale } from '../i18n';

export default {
  name: 'HelloWorld',
  components: { ROIModal, KeyFeature },
  props: {
    msg: String,
  },
  data() {
    return {
      isModalOpened: false,
      isSequenceReady: false,
      isBackgroundVisible: false,
      highResLoaded: 0,
      totalHighResAttempted: 0,
      allHighResLoaded: false,
    };
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    // ScrollTrigger.normalizeScroll(true);

    // ScrollSmoother.create({
    //   smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
    //   effects: true, // looks for data-speed and data-lag attributes on elements
    //   smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    // });

    // Adjust pin length based on screen size
    const isDesktop = window.innerWidth >= 1024;
    const pinDistance = isDesktop ? 1000 : 500;

    ScrollTrigger.create({
      trigger: '.pin-roaster',
      pin: '.pin-roaster',
      start: 'center center',
      end: `+=${pinDistance}`,
      pinSpacing: true,
    });

    this.setSequence();
    // Ensure canvas scales on resize (desktop and ultra-wide)
    window.addEventListener('resize', this.updateCanvasSize, { passive: true });
    this.updateCanvasSize();

    // Set up the GSAP animation for background sliding - fix to ensure it works regardless of class presence
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.pin-roaster',
        start: 'center center',
        end: '+=2000',
        scrub: 0.5,
      }
    });
    
    // Important: target the element directly, not the class
    tl.to('.pin-roaster', {
      backgroundPositionX: '100%',
      ease: 'none',
    });

    // Move the headline up only when it's stacked above the roaster (mobile/tablet)
    // Use gsap.matchMedia and revert on unmount
    this._mm = gsap.matchMedia();
    this._mm.add('(max-width: 1023px)', () => {
      gsap.to('.headline-hero', {
        y: -300,
        autoAlpha: 0.95,
        ease: 'none',
        scrollTrigger: {
          trigger: '.pin-roaster',
          start: 'center center',
          end: `+=${pinDistance}`,
          scrub: 1,
        }
      });
    });

    gsap.to('.coffee-bag', {
      bottom: '20px',
      ease: 'none',
      scrollTrigger: {
        trigger: '.coffee-bag',
        scrub: true,
      },
    });
    const boxes = gsap.utils.toArray('.box');
    boxes.forEach((box) => {
      const anim = gsap.fromTo(
        box,
        { autoAlpha: 0, y: 50 },
        { duration: 1, autoAlpha: 1, y: 0 }
      );
      ScrollTrigger.create({
        trigger: box,
        animation: anim,
        toggleActions: 'play none none none',
        once: true,
      });
    });

    // Hide header on scroll down, show on scroll up
    const headerEl = document.querySelector('.main-header');
    if (headerEl) {
      gsap.set(headerEl, { y: 0 });
      this._headerST = ScrollTrigger.create({
        start: 0,
        end: 'max',
        onUpdate: (self) => {
          if (self.direction === 1 && self.scroll() > 80) {
            gsap.to(headerEl, { y: -(headerEl.offsetHeight + 8), duration: 0.4, ease: 'power2.out', overwrite: true });
          } else if (self.direction === -1) {
            gsap.to(headerEl, { y: 0, duration: 0.4, ease: 'power2.out', overwrite: true });
          }
        }
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateCanvasSize);
    if (this._mm) {
      this._mm.revert();
    }
    if (this._headerST) {
      this._headerST.kill();
      this._headerST = null;
    }
  },
  methods: {
    renderRich(message) {
      if (typeof message !== 'string') return message;
      // Map any numeric placeholders like <0>...</0>, <1>...</1>, ... to <b>...</b>
      let html = message
        .replace(/<\s*(\d+)\s*>/g, '<b>')
        .replace(/<\s*\/\s*(\d+)\s*>/g, '</b>');

      // Support asterisk bold (*...*)
      html = html.replace(/\*(.*?)\*/g, '<b>$1</b>');

      // Support explicit line breaks: |n token, literal "\\n", CRLF, and actual newlines
      html = html
        .replace(/\|n/g, '<br>')
        .replace(/\\n/g, '<br>')
        .replace(/(\r\n|\r|\n)/g, '<br>');

      // Strip all tags except <b> and <br>
      html = html.replace(/<(?!\/?b\b|br\s*\/?\s*>)[^>]*>/gi, '');
      return html;
    },
    changeLocale(locale) {
      setLocale(locale);
    },
    getLocaleClass(locale) {
      const current = i18n.global.locale.value;
      return current === locale ? 'font-semibold text-brown' : 'text-zinc-400 hover:text-brown';
    },
    openModal() {
      this.isModalOpened = true;
    },
    openTallyForm() {
      if (window.Tally) {
        window.Tally.openPopup('3l5ldN', {
          layout: 'default',
          emoji: {
            text: '👋',
            animation: 'wave'
          },
          onSubmit: async (payload) => {
            console.log('✅ Tally form submitted', payload);

            // Link form submission with ROI session if it exists
            try {
              const fields = payload.fields || [];
              
              // Extract form data
              const formData = {
                companyName: fields.find(f => f.title === "Qual é o nome do seu negocio?")?.answer?.value || '',
                contactName: fields.find(f => f.title === "Seu nome")?.answer?.value || '',
                businessType: fields.find(f => f.title === "Qual é o seu tipo de negócio?")?.answer?.value || '',
                alreadyRoasting: fields.find(f => f.title === "Você já torra o próprio café hoje?")?.answer?.value || '',
                contactPreference: fields.find(f => f.title === "📬 Como prefere que a gente entre em contato (sem spam, prometo!)?")?.answer?.value || '',
                whatsapp: fields.find(f => f.title === "Qual é seu número de WhatsApp?")?.answer?.value || '',
                email: fields.find(f => f.title === "Qual é seu e-mail?")?.answer?.value || '',
                wantsPilot: fields.find(f => f.type === "CHECKBOXES")?.answer?.value?.includes("Quero receber novidades") || false
              };
              
              await linkFormSubmission(payload.respondentId, {
                formId: payload.formId,
                createdAt: payload.createdAt,
                ...formData
              });
            } catch (error) {
              console.error('Failed to link form submission:', error);
            }

            if (window.fbq) {
              window.fbq('track', 'Lead');
              console.log('✅ Facebook Lead event sent');
            }
          }
        });
      } else {
        console.warn('Tally not loaded');
      }
    },
    updateCanvasSize() {
      const canvas = document.getElementById('image-sequence');
      if (!canvas) return;
      // Control displayed size only; intrinsic size is set in setSequence
      const width = window.innerWidth;
      if (width >= 1536) {
        canvas.style.width = '700px';
        canvas.style.maxWidth = '700px';
        canvas.style.height = 'auto';
      } else if (width >= 1280) {
        canvas.style.width = '600px';
        canvas.style.maxWidth = '600px';
        canvas.style.height = 'auto';
      } else if (width >= 1024) {
        canvas.style.width = '500px';
        canvas.style.maxWidth = '500px';
        canvas.style.height = 'auto';
      } else {
        canvas.style.width = '100%';
        canvas.style.height = 'auto';
        canvas.style.maxWidth = '';
      }
      ScrollTrigger.refresh();
    },
    setSequence() {
      const canvas = document.getElementById('image-sequence');
      const context = canvas.getContext('2d');

      // Set canvas to be the original image dimensions for best quality
      const originalWidth = 1440;
      const originalHeight = 2000;
      
      // Set canvas to original image dimensions for best rendering quality
      canvas.width = originalWidth;
      canvas.height = originalHeight;
      
      // Use CSS to control displayed size
      this.updateCanvasSize();

      const startFrame = 0;
      const frameCount = 117 - startFrame;
      
      // Track loading progress
      let loadedCount = 0;
      
      // Setup for animation
      const images = [];
      const airpods = {
        frame: startFrame,
      };
      
      // Modified function to load low-res first, then replace with high-res
      const loadImageWithFallback = (index) => {
        return new Promise(resolve => {
          const imgPath = `/roastsequence/beyond-roast-${(startFrame + index + 1).toString()}`;
          const lowResPath = `/roastsequence/low/beyond-roast-${(startFrame + index + 1).toString()}.jpg`;
          const highResPath = `${imgPath}.png`;
          
          // First try loading the low-res version for speed
          const lowResImg = new Image();
          lowResImg.onload = () => {
            // Return the low-res image immediately to get things moving
            resolve(lowResImg);
            
            // Then start loading the high-res version in the background
            const highResImg = new Image();
            this.totalHighResAttempted++;
            
            highResImg.onload = () => {
              this.highResLoaded++;
              
              // Replace the low-res image with high-res once loaded
              images[index] = highResImg;
              
              // Check if all high-res images are loaded
              if (this.highResLoaded >= frameCount) {
                this.allHighResLoaded = true;
                
                // Now show the background - the animation will automatically work with the class
                this.isBackgroundVisible = true;
                
                // Force ScrollTrigger to recalculate after background appears
                setTimeout(() => {
                  ScrollTrigger.refresh();
                  //console.log('ScrollTrigger refreshed after background appeared');
                }, 100);
              }
              
              // If frame 0 (first frame) is loaded with high-res and we're still showing it
              // (because animation hasn't started or we're on frame 0), refresh it
              if (index === 0 && (!animationStarted || Math.floor(airpods.frame) === 0)) {
                //console.log('Re-rendering first frame with high-res');
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(highResImg, 0, 0, canvas.width, canvas.height);
              }
              // If this frame is currently displayed, re-render it
              else if (Math.floor(airpods.frame) === index && animationStarted) {
                //console.log(`Re-rendering frame ${index} with high-res`);
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(highResImg, 0, 0, canvas.width, canvas.height);
              }
            };
            
            highResImg.onerror = () => {
              console.error(`Failed to load high-res image: ${highResPath}`);
            };
            
            highResImg.src = highResPath;
          };
          
          lowResImg.onerror = () => {
            // If low-res fails, try high-res directly
            //console.log(`Low-res image not found, trying high-res: ${highResPath}`);
            const fallbackImg = new Image();
            this.totalHighResAttempted++;
            
            fallbackImg.onload = () => {
              this.highResLoaded++;
              
              // Check if all high-res images are loaded
              if (this.highResLoaded >= frameCount) {
                // console.log('All high-resolution images loaded');
                this.allHighResLoaded = true;
                
                // Now show the background - the animation will automatically work with the class
                this.isBackgroundVisible = true;
                
                // Force ScrollTrigger to recalculate after background appears
                setTimeout(() => {
                  ScrollTrigger.refresh();
                  // console.log('ScrollTrigger refreshed after background appeared');
                }, 100);
              }
              
              resolve(fallbackImg);
            };
            fallbackImg.onerror = () => {
              //console.error(`Failed to load both low-res and high-res images for frame ${index}`);
              resolve(null);
            };
            fallbackImg.src = highResPath;
          };
          
          lowResImg.src = lowResPath;
        });
      };
      
      // Load first image immediately to display as default
      loadImageWithFallback(0).then(firstImage => {
        if (firstImage) {
          // Display first frame immediately once it's loaded
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(firstImage, 0, 0, canvas.width, canvas.height);
          images[0] = firstImage;
          loadedCount++;
          
          // Make the canvas visible right away once first frame is loaded
          this.isSequenceReady = true;
          
          // Start animation with just a few frames to get things moving quickly
          if (loadedCount >= 5) {
            startAnimation();
          }
        }
      });
      
      // Load the rest of the images in the background with progressive enhancement
      const loadRemainingImages = () => {
        // Define key frames first for faster initial playback
        const keyFrameIndices = [];
        for (let i = 10; i < frameCount; i += 10) {
          keyFrameIndices.push(i);
        }
        
        // Load key frames first
        const loadKeyFrames = keyFrameIndices.map(i => {
          return loadImageWithFallback(i).then(img => {
            if (img) {
              images[i] = img;
              loadedCount++;
            }
            return img;
          });
        });
        
        // Then load the remaining frames in batches
        return Promise.all(loadKeyFrames).then(() => {
          // Start animation with keyframes if we have enough
          if (loadedCount >= 5 && !animationStarted) {
            startAnimation();
          }
          
          // Then load all remaining frames in small batches
          const loadBatches = [];
          const batchSize = 5;
          
          for (let batchStart = 1; batchStart < frameCount; batchStart += batchSize) {
            loadBatches.push(
              new Promise(batchResolve => {
                const batchPromises = [];
                
                for (let i = batchStart; i < batchStart + batchSize && i < frameCount; i++) {
                  // Skip frames we've already loaded as key frames
                  if (keyFrameIndices.includes(i) || i === 0) continue;
                  
                  batchPromises.push(
                    loadImageWithFallback(i).then(img => {
                      if (img) {
                        images[i] = img;
                        loadedCount++;
                      }
                      return img;
                    })
                  );
                }
                
                Promise.all(batchPromises).then(batchResolve);
              })
            );
          }
          
          return Promise.all(loadBatches);
        });
      };
      
      let animationStarted = false;
      
      // Function to start the animation
      const startAnimation = () => {
        if (animationStarted) return;
        animationStarted = true;
        
        // We'll show the background only when all high-res images are loaded
        // This has been moved to the high-res image loading logic
        
        // Start the GSAP animation
        gsap.to(airpods, {
          frame: frameCount - 1,
          snap: 'frame',
          ease: 'none',
          duration: images.length / 30,
          scrollTrigger: {
            start: 'top top',
            end: '+=800',
            scrub: 1,
          },
          onUpdate: render,
        });
      };
      
      // Start loading immediately
      loadRemainingImages();

      function render() {
        const frameIndex = Math.floor(airpods.frame);
        if (!images[frameIndex]) {
          // If the exact frame isn't loaded yet, find the closest loaded frame
          let closestIndex = 0;
          let minDistance = frameCount;
          
          for (let i = 0; i < images.length; i++) {
            if (images[i]) {
              const distance = Math.abs(i - frameIndex);
              if (distance < minDistance) {
                closestIndex = i;
                minDistance = distance;
              }
            }
          }
          
          if (images[closestIndex]) {
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(images[closestIndex], 0, 0, canvas.width, canvas.height);
          }
        } else {
          // We have the requested frame, draw it
          const imgToDraw = images[frameIndex];
        
          
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(imgToDraw, 0, 0, canvas.width, canvas.height);
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.roaster-hero {
  background-image: url('~@/assets/beyond-roast-bg.svg');
  background-repeat: no-repeat;
  background-size: 300%;
  background-position-y: center;
}

.pin-roaster {
  position: relative;
  min-height: 500px; // Ensure minimum height for container
  background-position-x: 0%; /* Start position - important for GSAP animation */
  
  /* subtle radial gradient overlay behind roaster */
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(70% 50% at 50% 30%, rgba(0,0,0,0.06), rgba(0,0,0,0) 60%);
    pointer-events: none;
    z-index: 0;
  }
  
  /* Default state - light gray background, no SVG */
  &:not(.roaster-hero) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #f5f5f5; /* Match your light-gray background */
      z-index: 0;
    }
  }
  
  /* When class is applied, add the background image but maintain position controlled by GSAP */
  &.roaster-hero {
    /* Faster transition for background appearance */
    transition: background-image 0.3s ease;
  }
  
  @media (min-width: 1024px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: 1280px) {
    min-height: 650px;
  }

  @media (min-width: 1536px) {
    min-height: 750px;
  }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.image-sequence-canvas {
  /* Let the JavaScript control the sizing */
  display: block;
  margin: 0 auto;
}

p {
  @apply text-xl;
  @apply text-zinc-400;
  @apply font-medium;
}

b {
  @apply text-green;
  @apply font-medium;
}

.product-image {
  @apply my-10;
}

section {
  @apply mb-14;
  @apply md:w-[60%];
  @apply lg:w-[55%];
  @apply xl:w-[50%];
  @apply 2xl:w-[48%];
  @apply mx-auto;
  @apply px-8;
}

body {
  @apply bg-light-gray;
}
</style>
